import React from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FullScreenLoader } from './FullScreenLoader';
import Icon from './Icon';

export interface ButtonPropsBase {
  variant?:
    | 'active'
    | 'muted'
    | 'white'
    | 'borderlike'
    | 'accent'
    | 'secondary'
    | 'highlight'
    | 'emphasis';
  size?: 'medium' | 'small';
  inverse?: boolean;
  block?: boolean;
  icon?: IconProp;
  iconSuffix?: IconProp;
  loading?: boolean;
}

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & ButtonPropsBase;

export default function Button(props: ButtonProps) {
  const {
    variant: variantProp = 'active',
    size,
    block,
    icon,
    iconSuffix,
    inverse,
    className: propClasses,
    onClick: propOnClick,
    children,
    loading,
    ...rest
  } = props;

  const variant = rest.disabled ? 'disabled' : variantProp;

  const classes = [
    'whitespace-nowrap leading-none flex items-center justify-center gap-2 border rounded-lg overflow-hidden font-bold',
    variant,
  ];

  if (block) classes.push('w-full');
  if (inverse) classes.push('inverse');
  if (loading) classes.push('relative');
  if (size === 'small') classes.push('px-3 py-2 text-sm');
  else classes.push('px-5 py-3');

  if (propClasses) classes.push(propClasses);
  classes.push('go-button');

  function handleOnClick(evt: React.MouseEvent<HTMLButtonElement>) {
    evt.stopPropagation();
    if (propOnClick) propOnClick(evt);
  }

  return (
    <button {...rest} className={classes.join(' ')} onClick={handleOnClick}>
      {icon && <Icon icon={icon} />}
      {children}
      {iconSuffix && <Icon icon={iconSuffix} />}
      {loading && <FullScreenLoader className={`bg-${variant}`} />}
    </button>
  );
}
